// extracted by mini-css-extract-plugin
export default {"cashContainer":"Cash_cashContainer__Aysfj","detailCard":"Cash_detailCard__kZ7Um"};